import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { UpskillSection } from '../components/home/UpskillSection';
import { ExperienceSection } from '../components/home/ExperienceSection';
import { LayoffTrackerSection } from '../components/home/LayoffTrackerSection';
import { SignUpSection } from '../components/home/SignUpSection';
import { FooterSection } from '../components/home/FooterSection';
import { PromoPopup } from '../components/subscriptions/PromoPopup';
import { useLocation } from 'react-router-dom';

export function Home() {
  const [isPromoOpen, setIsPromoOpen] = useState(false);
  const location = useLocation();

  React.useEffect(() => {
    // Show promo popup if coming from /promo
    if (location.state?.fromPromo) {
      setIsPromoOpen(true);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <UpskillSection />
      <ExperienceSection />
      <LayoffTrackerSection />
  
      <SignUpSection />
      <FooterSection />
      <PromoPopup isOpen={isPromoOpen} onClose={() => setIsPromoOpen(false)} />
    </div>
  );
}